import { render, staticRenderFns } from "./NumberInput.vue?vue&type=template&id=2d061402"
import script from "./NumberInput.vue?vue&type=script&lang=js"
export * from "./NumberInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports